import { render, staticRenderFns } from "./WeekTotalTags.vue?vue&type=template&id=79e9e774&scoped=true&"
import script from "./WeekTotalTags.vue?vue&type=script&lang=js&"
export * from "./WeekTotalTags.vue?vue&type=script&lang=js&"
import style0 from "./WeekTotalTags.vue?vue&type=style&index=0&id=79e9e774&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e9e774",
  null
  
)

export default component.exports